<template lang="pug">
  .p-30
    .row.align-items-center.flex-sm-row-reverse.mb-3
      .col-sm-auto.ml-auto.mb-3.mb-sm-0.text-center
        el-button(type='primary' @click="dialog = true") Add Company
      .col-sm.max-w-530
        el-input(
          v-model="searchInput"
          prefix-icon="el-icon-search"
          placeholder="Search by Name, Email or Company..."
        )

    .card
      .card-body
        el-table(:data="filteredItems" v-loading="loading" style="width: 100%")
          el-table-column(label="Company Name" prop="name" min-width="180")

          el-table-column(label="Address" min-width="200")
            template(slot-scope="props")
              div {{ props.row.address }}
              div {{ props.row.city }}, {{ props.row.state }}, {{ props.row.zip }}

          el-table-column(label="Email" prop="email" min-width="180")
          el-table-column(label="Phone" prop="phone" min-width="140")

          el-table-column(width="60")
            template(slot-scope="props")
              el-dropdown(@command="handleRowAction($event, props.row)" trigger="click")
                el-button(icon="el-icon-more" circle)
                el-dropdown-menu(slot="dropdown")
                  el-dropdown-item(command="editCompany") Edit Company
                  el-dropdown-item(command="manageCompany") Manage Company

    dialog-add-edit-company(
      v-if="dialog"
      :loading="loading"
      :dialog-visible.sync="dialog"
      :edited-item="editedItem"
      :form-title="formTitle"
      @save-item="saveCompany"
      @delete-item="deleteItem"
      @close-dialog="closeDialog"
    )
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import uuid from 'uuid-v4';
import { company as initCompany } from '@/data/init';
import { companies as dummyCompanies } from '@/data/static';
import CrudDialogMixin from '@/mixins/crudDialogMixin';
import SubscribeMixin from '@/mixins/subscribeMixin';
import DialogAddEditCompany from './DialogAddEditCompany.vue';

import {
  getCompanyRecords,
  createCompanyRecord,
  updateCompanyRecord,
} from '../../models/companies';

export default {
  name: 'Companies',
  components: { DialogAddEditCompany },
  mixins: [CrudDialogMixin, SubscribeMixin],

  data() {
    return {
      searchInput: '',
    };
  },

  computed: {
    ...mapGetters('users', ['me', 'scopedCompany', 'isSuperAdmin']),
    filteredItems() {
      return this.getFilteredItems();
    },
  },

  created() {
    if (!this.isSuperAdmin) {
      this.$router.push('/companies');
      return;
    }
    this.initData();
    this.subscribeToCompanyEvents();
  },

  beforDestroy() {
    console.log('before dstroying...');
  },

  methods: {
    ...mapActions('users', ['setScopedCompany']),

    initComp() {
      // init company data
      this.editedItem = JSON.parse(JSON.stringify(initCompany));
      this.defaultItem = JSON.parse(JSON.stringify(initCompany));
      setTimeout(() => {
        this.items = dummyCompanies;
        this.loading = false;
      }, 1000);
    },
    subscribeToCompanyEvents() {
      this.subscribeAndInvoke(
        [
          'onCreateCompany',
          'onUpdateCompany',
          'onDeleteCompany',
        ],
        this.getCompanyList,
      );
    },

    handleRowAction(command, row) {
      console.log('handle row Action ', command);
      if (command === 'editCompany') {
        return this.editItem(row);
      }
      if (command === 'manageCompanyUsers') {
        return this.$router.push(`/companies/${row.id}/users`);
      }
      if (command === 'manageCompanyMeetings') {
        return this.$router.push(`/companies/${row.id}/meetings`);
      }
      console.log(row);
      this.setScopedCompany(row);
      return this.$router.push('/users');
    },

    filterItem(item) {
      return item.toLowerCase().includes(this.searchInput.toLowerCase());
    },

    getFilteredItems() {
      const items = this.items.filter(
        (item) => this.filterItem(item.name)
          || this.filterItem(item.phone)
          || this.filterItem(item.email),
      );
      return items;
    },

    initData() {
      this.editedItem = JSON.parse(JSON.stringify(initCompany));
      this.defaultItem = JSON.parse(JSON.stringify(initCompany));
      this.getCompanyList();
      this.loading = false;
    },

    getCompanyList() {
      getCompanyRecords().then((res) => {
        this.items = res.data.listCompanys.items;
      });
    },

    saveCompany() {
      this.loading = true;
      if (this.editedItem.id) {
        delete this.editedItem.createdAt;
        delete this.editedItem.updatedAt;
        this.updateCompany();
      } else {
        this.editedItem.id = uuid();
        this.createCompany();
      }
    },

    createCompany() {
      createCompanyRecord(this.editedItem).then((res) => {
        console.log(res);
      }).catch((err) => {
        console.log(err);
      }).finally(() => {
        this.closeDialog();
        this.loading = false;
      });
    },

    updateCompany() {
      updateCompanyRecord(this.editedItem).then((res) => {
        console.log(res);
      }).catch((err) => {
        console.log(err);
      }).finally(() => {
        this.closeDialog();
        this.loading = false;
      });
    },
  },
};
</script>
